var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('span',{staticClass:"ml-1 font-weight-bold "},[_vm._v(_vm._s(_vm.label)+" "),_c('el-tag',[_vm._v(_vm._s(_vm.value))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }